import { gql } from "@apollo/client";
import { AnimalInfo, PANEL_ANIMAL_FRAGMENT } from "../../AnimalDataCalls/GQLCalls/getAnimalCall";

export const GET_LF_SECTION_INFO = gql`
  query Info($domain: String!, $input: BasicQueryInfoInput!, $idIdentifier: String, $ifFeedCurveBaseInfoOnly: Boolean!, 
  $ifFeedCurveInfo: Boolean!, $ifSpreading: Boolean!, $ifSkipConsumption: Boolean!, $ifSkipLastTenDaysConsumption: Boolean!) {
    section {
      info(domain: $domain, input: $input) {
        section_id
        name
        panel_section_type
        section_locations {
          name,
          location_id
          visual
          animals(domain: $domain) {
            ...AnimalFields
          }
        }
        system_id
      }
    }
  }
${PANEL_ANIMAL_FRAGMENT}
`

export interface LfSectionsInfo {
  section_id: number;
  system_id: number;
  name: string;
  panel_section_type: number;
  section_locations: LfLocation[]
}

export interface LfLocation {
  name: string,
  location_id: number;
  visual?: string;
  animals: AnimalInfo[];
}

export interface LfSectionResponse {
  section: {
    info: LfSectionsInfo[]
  }
}